<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { getSelectSize } from 'header/utils/getSelectSize';
    import type {
        InteractiveTitleSelectClearableDefinition,
        InteractiveTitleSelectNumberClearableDefinition,
    } from '../../types';

    interface Props {
        field:
            | InteractiveTitleSelectClearableDefinition
            | InteractiveTitleSelectNumberClearableDefinition;
    }

    let { field }: Props = $props();
    let options = $derived(field.options as Options[]);
    let selectedIndex = $derived(field.options.findIndex(option => option.key === field.value));
    let selectedLabel = $derived(selectedIndex !== -1 ? field.options[selectedIndex].label : '');

    $effect(() => {
        changeSelectSize(selectedLabel);
    });

    type Options =
        | InteractiveTitleSelectClearableDefinition['options'][number]
        | InteractiveTitleSelectNumberClearableDefinition['options'][number];

    let select = $state<HTMLSelectElement | null>(null);
    const emptyOptionLabel = '---';

    const changeSelectSize = (selectedLabel: string) => {
        if (!select) return;
        select.style.width = getSelectSize(selectedLabel, select);
    };

    const dispatch = createEventDispatcher();
    const onChange = (e: { currentTarget: HTMLSelectElement }) => {
        if (e.currentTarget.value === 'null') {
            changeSelectSize(emptyOptionLabel);
            return dispatch('change', {
                field: {
                    ...field,
                    value: null,
                },
            });
        }

        const optionIndex = parseInt(e.currentTarget.value, 10);
        const value = field.options[optionIndex]?.key || field.value;

        dispatch('change', {
            ...field,
            value,
        });
    };
</script>

<select bind:this={select} value={selectedIndex} oninput={onChange}>
    <option value={null}>{emptyOptionLabel}</option>
    {#each options as { label }, index}
        <option value={index}>{label}</option>
    {/each}
</select>

<style lang="scss" scoped>
</style>
